export const naturalStringSort = (a: string, b: string): number => {
  return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
};

export const capitalizeFirstLetter = (string: string): string => {
  return String(string).charAt(0).toUpperCase() + String(string).slice(1);
};

export const lowercaseFirstLetter = (string: string): string => {
  return String(string).charAt(0).toLowerCase() + String(string).slice(1);
};
